import { API_BASE_URL } from "../../constants/api";

export const authenticatedApiRequest = (accessToken: string, path: string, options: RequestInit = {}) =>
  fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
